import { useCallback, useLayoutEffect, useRef, useState } from 'react';
import { StyleSheet } from 'react-native';
import { TalentsContainer } from '../../components/ScreenContainer/TalentsContainer';
import { Container } from '@mui/system';
import { ITalentData } from '../../redux/talent/types';
import { useDispatch, useSelector } from 'react-redux';
import { navigate } from '../../redux/navigator/action';
import { searchingTalentSelector, talentSearchSelector, talentSelector } from '../../selectors/selectors';
import { ROUTES } from '../../types/global/routes.types';
import { replaceRouteParam } from '../../utils/routesProcessor';
import { deleteTalent, getSavedTalents, searchTalent, updateTalent } from '../../redux/talent/actions';
import _ from 'lodash';
import { IEditTalentPayload } from '../../components/ScreenContainer/TalentsContainer/TalentsContainer';

const COUNT = 3;
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
    },
});

const Talents = () => {
    const dispatch = useDispatch();
    const [searchTerm, setSearchTerm] = useState('');
    const talents = useSelector(talentSelector);
    const talentSearchData = useSelector(talentSearchSelector);
    const searchingTalent = useSelector(searchingTalentSelector);

    const handleGetSavedTalents = useCallback(async () => {
        dispatch(searchTalent({ searchTerm: searchTerm }));
        dispatch(getSavedTalents({ page: 1, limit: 5 }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useLayoutEffect(() => {
        // This here adds an additional re-render on the app . Check to see if you can move this to appLayout
        handleGetSavedTalents();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleOnUserPress = (talent: ITalentData) => {
        const route = replaceRouteParam(ROUTES.ESMY_PROFILE, 'profileId?', talent.talent.userName);
        dispatch(navigate({ routes: route }));
    };
    const handleClearSearch = () => {
        setSearchTerm('');
    };

    const handleSearch = useRef(
        _.debounce(searchTerm => {
            if (searchTerm.length > COUNT && !searchingTalent) {
                dispatch(searchTalent({ searchTerm }));
            }
        }, 1000),
    ).current;

    const handleChange = (event: any) => {
        const searchTerm = event.target.value;
        setSearchTerm(searchTerm);
        handleSearch(searchTerm);
    };

    const handleDeleteTalent = (savedTalent: ITalentData) => {
        dispatch(
            deleteTalent({
                documentId: savedTalent._id,
            }),
        );
    };

    const handleOnEditTalent = (details: IEditTalentPayload) => {
        dispatch(updateTalent({ documentId: details.id, payload: { note: details.note, tags: details.tags } }));
    };

    return (
        <Container disableGutters style={styles.container} maxWidth={false}>
            <TalentsContainer
                talentData={searchTerm.length > COUNT ? talentSearchData : talents}
                handleUserSuggestionClick={handleOnUserPress}
                loading={searchingTalent}
                onDeleteTalent={handleDeleteTalent}
                onTalentSearchClear={handleClearSearch}
                onChange={handleChange}
                searchTerm={searchTerm}
                onEditTalent={handleOnEditTalent}
            />
        </Container>
    );
};

export { Talents };
